import { DocumentPermissionsRequest, getLimitedDocumentPermission, getPrivateDocumentPermission, getPublicDocumentPermission } from "../../.."

export const definedSpecificGroups = {
    limited: 'Limited',
    private: 'Private',
    public: 'Public',
    unknown: 'Unknown'
}

export const getSpecificGroupKeyForOption = (o: DocumentPermissionsRequest) => {
    if(!!o.isLimitedToMembers) return 'Limited'
    if(!!o.isPrivate) return 'Private'
    if(!o.isPrivate && !o.groupUid) return 'Public'
    if(!!o.groupUid) return o.groupUid
    return 'Unknown'
}
export const getDocPermissionsByDefinedKey = (key: string): [boolean, DocumentPermissionsRequest] => {
    if(definedSpecificGroups.limited === key) return [true, getLimitedDocumentPermission()]
    if(definedSpecificGroups.private === key) return [true, getPrivateDocumentPermission()]
    if(definedSpecificGroups.public === key) return [true, getPublicDocumentPermission()]
    return [false, {} as DocumentPermissionsRequest]
}

export type GetPermissionLabel = (o: DocumentPermissionsRequest) => string
export const dtoDocPermissionsToSpecificOptions = (options: DocumentPermissionsRequest[], getPermissionLabel: GetPermissionLabel): {key: string, title: string}[] => {
    return options.map((o) => {
        const title = getPermissionLabel(o)
        const key = getSpecificGroupKeyForOption(o)
        return {key, title}
    })
}
export const filterDocPermissionsAsSpecificOptions = (options: DocumentPermissionsRequest[], specificGroupsKeys: string): DocumentPermissionsRequest[] => {
    const selectedKeys = specificGroupsKeys.split(";")

    const specificOptions = options.filter((o) => {
        const key = getSpecificGroupKeyForOption(o)
        return selectedKeys.includes(key)
    })
    return specificOptions
}